import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatusCalculationRoutingModule } from './status-calculation-routing.module';
import { StatusCalculationComponent } from './status-calculation.component';
import { DxDataGridModule, DxSelectBoxModule, DxTextBoxModule, DxCheckBoxModule, DxTagBoxModule, DxAutocompleteModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [StatusCalculationComponent],
  imports: [
    CommonModule,
    StatusCalculationRoutingModule,
    DxDataGridModule,
    I18nModule,
    ReactiveFormsModule,
    FormsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxAutocompleteModule
  ]
})
export class StatusCalculationModule { }
